//@ts-nocheck
import {
  Box,
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import Pluralize from "pluralize";
import React from "react";

const SubmitConfirmation: React.FC<{
  onClose: () => void;
  isOpen: boolean;
  onQuizSubmission: () => Promise<any>;
  remainingQs: Array<any>;
  questions: Array<any>;
  setCurrentQ: (...params) => void;
  setShowSubmit: (param: boolean) => void;
  timeElapsed?: boolean;
  loading: boolean;
}> = ({
  onClose,
  isOpen,
  onQuizSubmission,
  remainingQs = [],
  questions,
  setCurrentQ,
  setShowSubmit,
  timeElapsed,
  loading,
}) => {
  let isUanswered = questions.length === remainingQs.length;
  let isRemaining = remainingQs.length > 0 && !isUanswered;
  function handleClick(num) {
    setCurrentQ(num);
    setShowSubmit(true);
    onClose();
  }

  React.useEffect(() => {
    if (timeElapsed && !loading) {
      console.log(timeElapsed);
      onQuizSubmission().then(() => {});
    }
  }, [timeElapsed]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent mx={6} top={["2.5rem", "4.5rem"]} rounded="lg">
        <ModalHeader fontWeight="bold" fontSize="lg">
          {timeElapsed ? "Time has Elapsed" : "Ready to submit?"}
        </ModalHeader>
        {timeElapsed ? (
          <ModalBody pb={8}>
            <Box>Time has elapsed, submitting your quiz</Box>
          </ModalBody>
        ) : (
          <>
            <ModalCloseButton />
            <ModalBody pb={8}>
              {isUanswered ? (
                <Box>
                  It appears you didn't answer any question. Do you want to
                  submit anyway?
                </Box>
              ) : isRemaining ? (
                <DisplayRemainingQs {...{ remainingQs, handleClick }} />
              ) : (
                <Box>
                  Looks good! Once submitted, you won't be able to make any
                  changes. Proceed to submit.
                </Box>
              )}
            </ModalBody>
          </>
        )}

        <ModalFooter borderTopWidth="2xs" borderColor="neutral.500">
          {timeElapsed ? (
            <Button
              colorScheme="blue"
              isLoading={loading}
              loadingText="Submitting"
              onClick={onQuizSubmission}
            >
              Submit
            </Button>
          ) : (
            <>
              <Button variant="ghost" mr={3} onClick={onClose}>
                Close
              </Button>
              <Button
                colorScheme="blue"
                isLoading={loading}
                loadingText="Submitting"
                onClick={onQuizSubmission}
              >
                {isRemaining || isUanswered ? "Submit anyway" : "Submit"}
              </Button>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const DisplayRemainingQs = ({ remainingQs, handleClick }) => {
  return (
    <Stack spacing={5}>
      <Text>
        It seems you didn't answer{" "}
        {Pluralize("question", remainingQs.length, true)}. Was this an omission?
        Click to go to the question below or proceed to submit anyway.
      </Text>
      <Grid
        templateColumns={["repeat(4,1fr)", "repeat(6, 1fr)"]}
        columnGap={3}
        rowGap={3}
      >
        {remainingQs.map((num) => (
          <Box
            py={1}
            px={2}
            rounded="lg"
            borderWidth="xs"
            borderColor="gray.700"
            key={num}
            onClick={() => handleClick(num)}
            _hover={{
              bg: "neutral.100",
              borderColor: "gray.800",
              color: "gray.800",
            }}
            textAlign="center"
            fontSize="sm"
            fontWeight="medium"
            color="gray.700"
            cursor="pointer"
          >
            Q{num}
          </Box>
        ))}
      </Grid>
    </Stack>
  );
};

export default SubmitConfirmation;
